export default {
	USERNAME_MAX_LENGTH: 255,
	PASSWORD_MAX_LENGTH: 2000,
	BASE_URL_MAX_LENGTH: 2048,
	TOKEN_NAME_MAX_LENGTH: 2000,
	AUTHORIZATION_HEADER: 'Authorization',
	ACCESS_TOKEN_URL_PARAMETER: 'access_token',
	ACCESS_TOKEN_PLACEHOLDER: '[access-token]',
	REFRESH_TOKEN_URL_PARAMETER: 'refresh_token',
	REFRESH_TOKEN_PLACEHOLDER: '[refresh-token]',
	GRANT_TYPE_URL_PARAMETER: 'grant_type',
	TOKEN_TYPE_PLACEHOLDER: '[token-type]',
	CLIENT_ASSERTION_PLACEHOLDER: '[client-assertion]',
	ACCESS_TOKEN_STRATEGY: {
		HEADER: 'header',
		URL_PARAMETER: 'urlParameter',
		REQUEST_BODY: 'requestBody',
	},
	WS_VENDOR_TYPE : {
		ORACLE_NETSUITE: 'oracle-netsuite',
	}
}